export function getPublicAppUrl() {
  if (process.env.REACT_APP_PUBLIC_APP_URL) {
    return process.env.REACT_APP_PUBLIC_APP_URL.replace(/\/$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:5000";
  }
  return window.location.origin;
}
